<!-- <div class="progress-bg-indicator-all-page" id="progress-indicator-id1"></div>
<div class="progress-indicator-all-page " id="progress-indicator-id2"></div>
<div class="message" *ngIf="progressText" [innerHTML]="progressText"></div> -->
<div *ngIf="isVisible" class="spinner-overlay">
<dds-spinner [size]="spinnerOptions.size??''"
             [theme]="spinnerOptions.theme??''"
             [customClass]="spinnerOptions.customClass??''"
             [isInverse]="spinnerOptions.isInverse??false"
             [thickness]="spinnerOptions.thickness??''"></dds-spinner>
</div>